import { StandardizedLabelRelationsType } from '../../../../../schemas/standardizedLabel.schemas';

type SchemaType = {
    schemaId: number;
    schemaName: string;
    descriptors: { descriptorLabel: string }[];
};

type SchemasMapType = {
    [schemaId: string]: SchemaType;
};

type CompanyType = {
    companyId: number;
    companyName: string;
    schemasMap: SchemasMapType;
    descriptorsCount: number;
};

export type CompaniesMapType = {
    [companyId: string]: CompanyType;
};

export type StandardizedLabelRelationModelType = {
    standardizedLabelId: number;
    standardizedLabelName: string;
    companiesMap: CompaniesMapType;
    descriptorsCount: number;
};

export type TableModelType = StandardizedLabelRelationModelType[];

export function getTableModel(standardizedLabelRelations: StandardizedLabelRelationsType): TableModelType {
    const tableModel = standardizedLabelRelations.map((standardizedLabelRelation) => {
        const standardizedLabel: StandardizedLabelRelationModelType = {
            standardizedLabelId: standardizedLabelRelation.standardizedLabelId,
            standardizedLabelName: standardizedLabelRelation.standardizedLabelName.trim(),
            companiesMap: {},
            descriptorsCount: 0,
        };

        standardizedLabel.companiesMap = standardizedLabelRelation.schemaRelations.reduce((acc, schemaRelation) => {
            const companyId = schemaRelation.companyId;
            if (!acc[companyId]) {
                acc[companyId] = {
                    companyId: companyId,
                    companyName: schemaRelation.companyName,
                    schemasMap: {},
                    descriptorsCount: 0,
                };
            }
            const company = acc[companyId];
            const schemaId = schemaRelation.schemaId;
            if (!company.schemasMap[schemaId]) {
                company.schemasMap[schemaId] = {
                    schemaId: schemaId,
                    schemaName: schemaRelation.schemaName,
                    descriptors: [],
                };
            }

            company.schemasMap[schemaId].descriptors.push(...schemaRelation.descriptors);
            company.descriptorsCount += schemaRelation.descriptors.length;
            standardizedLabel.descriptorsCount += schemaRelation.descriptors.length;

            return acc;
        }, {} as CompaniesMapType);

        return standardizedLabel;
    });

    tableModel.sort((a, b) => a.standardizedLabelName.localeCompare(b.standardizedLabelName));
    return tableModel;
}
